"use client";

import * as React from "react";
import cx from "clsx";
import handleKeyDown from "../../utils/handleKeyDown";
import Separator from "../../Separator";
import { ItinerarySegmentProvider } from "./context";
import { spaceAfterClasses } from "../../common/tailwind";
const ItinerarySegment = ({
  children,
  spaceAfter,
  dataTest,
  noElevation,
  actionable = true,
  banner,
  onClick,
  onExpand,
  onCollapse
}) => {
  const content = React.Children.toArray(children);
  const [opened, setOpened] = React.useState(false);
  const handleClick = ev => {
    ev.stopPropagation();
    if (onClick) onClick(ev);
    if (!opened && onExpand) onExpand(ev);
    if (opened && onCollapse) onCollapse(ev);
    setOpened(prev => !prev);
  };
  const parts = /*#__PURE__*/React.createElement("div", {
    className: "pt-300",
    role: "button",
    tabIndex: 0,
    onClick: handleClick,
    onKeyDown: handleKeyDown(() => setOpened(prev => !prev))
  }, React.Children.map(children, (el, i) => {
    if (! /*#__PURE__*/React.isValidElement(el)) return null;
    return /*#__PURE__*/React.createElement(ItinerarySegmentProvider, {
      index: i,
      opened: opened,
      toggleOpened: ev => {
        if (document && document.getSelection()?.type !== "Range") handleClick(ev);
      },
      last: i === content.length - 1,
      isNextHidden: Boolean(content[i + 1]?.props?.hidden),
      isPrevHidden: Boolean(content[i - 1]?.props?.hidden),
      isBanner: !!banner,
      count: content.length,
      isHidden: !!(el.props && el.props.hidden),
      noElevation: !!noElevation
    }, el);
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: cx("rounded-150 pb-300 px-0", spaceAfter && spaceAfterClasses[spaceAfter], !noElevation && "shadow-fixed", actionable && !noElevation && "hover:shadow-level2 focus:shadow-level2"),
    "data-test": dataTest
  }, parts, Boolean(banner) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Separator, {
    spaceAfter: "small"
  }), banner));
};
export default ItinerarySegment;